export default __webpack_public_path__ + "static/media/DWFavicon.57b6b158.png";